import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '..';
import { accountService } from '../../services';
import { Loading, PupsLocation } from '../../models';

interface AccountState {
  selectedLocation: null | PupsLocation;
  selectLocationLoading: Loading;
  pupsLocations: PupsLocation[];
  pupsLocationsLoading: Loading;
  selectForgetPasswordLoading: Loading;
  totalEnCours: number;
}

const name = 'account';
const initialState: AccountState = {
  selectedLocation: null,
  selectLocationLoading: 'idle',
  pupsLocations: [],
  pupsLocationsLoading: 'idle',
  selectForgetPasswordLoading: 'idle',
  totalEnCours: 0,
};

export const findSelectedLocation = createAsyncThunk(
  `${name}/findSelectedLocation`,
  async (id: string | number, { rejectWithValue }) => {
    try {
      const response = await accountService.getLocationGeneralInfo(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchPupsLocations = createAsyncThunk(
  `${name}/list-management-pups-accounts`,
  async (query: { searchText: string | undefined }, { rejectWithValue }) => {
    try {
      const response = await accountService.getPupsLocations(query);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const forgetPassword = createAsyncThunk(
  `${name}/forgetPassword`,
  async (credentials: { email: string }, { rejectWithValue }) => {
    try {
      const response = await accountService.forgetPassword(credentials);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const accountSlice = createSlice({
  name,
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    // signOut(state) {
    //   state.accessToken = null;
    //   state.profile = null;
    //   Cookies.remove('access_token');
    //   removeAxiosToken();
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgetPassword.pending, (state) => {
        state.selectForgetPasswordLoading = 'pending';
      })
      .addCase(forgetPassword.fulfilled, (state, action) => {
        state.selectForgetPasswordLoading = 'idle';
      })
      .addCase(forgetPassword.rejected, (state) => {
        state.selectForgetPasswordLoading = 'idle';
      });
    builder
      .addCase(findSelectedLocation.pending, (state) => {
        state.selectLocationLoading = 'pending';
      })
      .addCase(findSelectedLocation.fulfilled, (state, action) => {
        state.selectLocationLoading = 'idle';
        state.selectedLocation = action.payload.account;
        state.totalEnCours = action.payload.totalEnCours;
      })
      .addCase(findSelectedLocation.rejected, (state) => {
        state.selectLocationLoading = 'idle';
      });
    builder
      .addCase(fetchPupsLocations.pending, (state) => {
        state.pupsLocationsLoading = 'pending';
      })
      .addCase(fetchPupsLocations.fulfilled, (state, action) => {
        state.pupsLocationsLoading = 'idle';
        state.pupsLocations = action.payload.data;
      })
      .addCase(fetchPupsLocations.rejected, (state) => {
        state.pupsLocationsLoading = 'idle';
      });
  },
});

export const selectSelectedLocation = (state: RootState) =>
  state.account.selectedLocation;
export const selectSelectLocationLoading = (state: RootState) =>
  state.account.selectLocationLoading;
export const selectTotalEnCours = (state: RootState) =>
  state.account.totalEnCours;
export const selectPupsLocations = (state: RootState) =>
  state.account.pupsLocations;
export const selectForgetPasswordLoading = (state: RootState) =>
  state.account.selectForgetPasswordLoading;
export const selectPupsLocationsLoading = (state: RootState) =>
  state.account.pupsLocationsLoading;

export default accountSlice.reducer;
